import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

const auth = app.auth();

auth.settings.appVerificationDisabledForTesting = false;

export const enrollUserInMFA = async (
  verificationId: string,
  verificationCode: string,
) => {
  const multiFactorSession = await auth.currentUser?.getIdTokenResult();
  if (!multiFactorSession) {
    throw new Error('User must be authenticated to enroll in MFA');
  }

  const phoneAuthCredential = firebase.auth.PhoneAuthProvider.credential(
    verificationId,
    verificationCode,
  );

  const multiFactorAssertion =
    firebase.auth.PhoneMultiFactorGenerator.assertion(phoneAuthCredential);

  await auth.currentUser?.multiFactor.enroll(
    multiFactorAssertion,
    'Phone Number',
  );

  await firebase.auth().currentUser?.reload();

  return firebase.auth().currentUser;
};

export default auth;
